import { Col, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import Section from '~/layouts/Section ';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetPayload } from '~/controllers/wizard';
import styled from 'styled-components';

const AutomatedOnboardingErrors = () => {
  const { t } = useTranslation('ksaCompletion');
  const payload = useGetPayload();

  return (
    <StyledSection>
      <Typography.Title level={5} className="Section-Header">
        {t('Automated onboarding errors').toUpperCase()}
      </Typography.Title>
      <Row gutter={16}>
        <Col span={8}>
          <Typography.Paragraph strong>{t('Date')}</Typography.Paragraph>
        </Col>
        <Col span={16}>
          <Typography.Paragraph strong>{t('Reason')}</Typography.Paragraph>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>{dayjs(payload?.automatedOnboardingError?.date).format('DD/MM/YYYY hh:mm:ss')}</Col>
        <Col span={16}>{payload?.automatedOnboardingError?.error}</Col>
      </Row>
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  .Section-Header {
    margin-bottom: 24px;
  }
`;

export default AutomatedOnboardingErrors;
